import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Header, Image } from 'semantic-ui-react';

import styles from './ModalTemplate.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const ModalTemplate = ({ children, trigger, dimmer, header, buttons, visible, scrolling, onToggleModal, ...rest }) => {
  return (
    <Modal
      {...rest}
      dimmer={
        dimmer
        // || 'inverted'
      }
      open={visible}
      trigger={trigger}
      onClose={() => {
        onToggleModal('');
      }}
      closeIcon={typeof rest.closeIcon !== 'undefined' ? rest.closeIcon : true}>
      {/* <Image className={cx('close-icon')} src="/img/common/close.png" /> */}
      <Header>{header}</Header>

      <Modal.Content
        // scrolling 은 props 인데 bug? 로 인해 직접 class 에 넣는 임시 처리
        className={cx(scrolling ? 'scrolling' : '')}>
        {children}
      </Modal.Content>
      {buttons ? <Modal.Actions>{buttons}</Modal.Actions> : ''}
    </Modal>
  );
};

ModalTemplate.propTypes = {
  visible: PropTypes.bool,
  onToggleModal: PropTypes.func
};

export default ModalTemplate;



// WEBPACK FOOTER //
// ./src/script/components/template/ModalTemplate.js